import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useThemeAssetMap } from '../../../lib/ui-theme/hooks/use-theme-assets';
import { AssetKeys } from '../../../lib/ui-theme/assets/asset-keys';
import './style.styl';

const propTypes = {
	className: PropTypes.string,
	alt: PropTypes.string,
};
const defaultProps = {
	className: '',
	alt: 'loading',
};

function ClientLoadingIcon({
	className,
	alt,
}) {
	const { imgLoading: ImgLoading } = useThemeAssetMap({
		imgLoading: AssetKeys.IMG_LOADING,
	});

	return (
		<img
			className={cx('client-loading-icon', className)}
			src={ImgLoading}
			alt={alt}
		/>
	);
}

ClientLoadingIcon.propTypes = propTypes;
ClientLoadingIcon.defaultProps = defaultProps;

export default memo(ClientLoadingIcon);
